import _createForOfIteratorHelper from "/var/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/var/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/var/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { PureComponent, createElement, Fragment, createRef, Component } from 'react';
import { createPortal } from 'react-dom';
import { bind } from 'lodash-decorators';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function classNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }
  return classes.filter(function (className) {
    return className;
  }).join(' ');
}
var getIntercomFromFrame = function getIntercomFromFrame(frame) {
  return frame.contentWindow.Intercom;
};
var objectEqual = function objectEqual(object1, object2) {
  return JSON.stringify(object1) === JSON.stringify(object2);
};
function injectCustomStyles(frame, styles) {
  var contentWindow = frame.contentWindow;
  var node = document.createElement('style');
  node.innerHTML = styles;
  contentWindow.document.head.appendChild(node);
}
var Portal = /*#__PURE__*/function (_PureComponent) {
  _inherits(Portal, _PureComponent);
  var _super = _createSuper(Portal);
  function Portal() {
    _classCallCheck(this, Portal);
    return _super.apply(this, arguments);
  }
  _createClass(Portal, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return createPortal(children, document.body);
    }
  }]);
  return Portal;
}(PureComponent);
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var ImportIsolatedRemote = "ImportIsolatedRemote_ImportIsolatedRemote__2bxiR";
var css = ".ImportIsolatedRemote_ImportIsolatedRemote__2bxiR {\n  width: 0;\n  height: 0;\n  border: none; }\n";
styleInject(css);
var ImportIsolatedRemote$2 = /*#__PURE__*/function (_PureComponent2) {
  _inherits(ImportIsolatedRemote$2, _PureComponent2);
  var _super2 = _createSuper(ImportIsolatedRemote$2);
  function ImportIsolatedRemote$2() {
    var _this;
    _classCallCheck(this, ImportIsolatedRemote$2);
    _this = _super2.apply(this, arguments);
    _this.frameNode = createRef();
    _this.scriptNode = null;
    return _this;
  }
  _createClass(ImportIsolatedRemote$2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var frame = this.frameNode.current;
      var _this$props = this.props,
        source = _this$props.source,
        onImported = _this$props.onImported;
      if (!frame || !frame.contentWindow) {
        return;
      }
      var contentWindow = frame.contentWindow;
      var script = document.createElement('script');
      script.src = source;
      this.scriptNode = script;
      function loadScript() {
        contentWindow.document.body.appendChild(script);
        script.onload = function () {
          return onImported(frame);
        };
      }
      if (frame.contentDocument.readyState === 'uninitialized') {
        frame.onload = loadScript;
        return;
      }
      loadScript();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var scriptNode = this.scriptNode,
        frame = this.frameNode.current;
      if (frame) {
        frame.onload = null;
      }
      if (scriptNode) {
        scriptNode.onload = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var title = this.props.title;
      return createElement(Portal, null, createElement("iframe", {
        className: ImportIsolatedRemote,
        title: title,
        ref: this.frameNode
      }));
    }
  }]);
  return ImportIsolatedRemote$2;
}(PureComponent);
var LAUNCHER_SIZE_PIXELS = 60;
var LAUNCHER_MARGIN_PIXELS = 20;
var BorderlessFrameObserver = /*#__PURE__*/function (_Component) {
  _inherits(BorderlessFrameObserver, _Component);
  var _super3 = _createSuper(BorderlessFrameObserver);
  function BorderlessFrameObserver() {
    var _this2;
    _classCallCheck(this, BorderlessFrameObserver);
    _this2 = _super3.apply(this, arguments);
    _this2.observer = null;
    return _this2;
  }
  _createClass(BorderlessFrameObserver, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var frame = this.props.frame;
      this.observeNode(frame.contentWindow.document.body, this.handleBodyMutation, {
        childList: true
      });
      this.injectCustomGradientStyles();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cleanObserver();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }, {
    key: "injectCustomGradientStyles",
    value: function injectCustomGradientStyles() {
      var frame = this.props.frame;
      injectCustomStyles(frame, "\n    .intercom-gradient {\n      width: 100% !important;\n      height: 100% !important;\n    }\n  ");
    }
  }, {
    key: "observeNode",
    value: function observeNode(nodeToObserve, onMutation, options) {
      this.cleanObserver();
      var observer = new MutationObserver(onMutation);
      observer.observe(nodeToObserve, options);
      this.observer = observer;
      return observer;
    }
  }, {
    key: "cleanObserver",
    value: function cleanObserver() {
      var observer = this.observer;
      if (observer) {
        observer.disconnect();
      }
    }
  }, {
    key: "handleBodyMutation",
    value: function handleBodyMutation(_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        body = _ref2[0].target;
      var intercomAppNode = body.querySelector('.intercom-app');
      this.observeNode(intercomAppNode, this.handleIntercomAppMutation, {
        attributes: true,
        subtree: true
      });
    }
  }, {
    key: "handleIntercomAppMutation",
    value: function handleIntercomAppMutation(mutations) {
      var _this$props2 = this.props,
        launcher = _this$props2.launcher,
        onSizesUpdate = _this$props2.onSizesUpdate;
      var _iterator = _createForOfIteratorHelper(mutations),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var target = _step.value.target;
          var node = target;
          if (!node.classList.contains('intercom-borderless-frame') && !node.classList.contains('intercom-notifications-frame')) {
            continue;
          }
          var height = node.style.height,
            offsetWidth = node.offsetWidth;
          var finalWidth = launcher ? offsetWidth + LAUNCHER_MARGIN_PIXELS : offsetWidth;
          var finalHeight = height || '0px';
          if (height && launcher) {
            finalHeight = addMarginToPixels(height, LAUNCHER_SIZE_PIXELS + LAUNCHER_MARGIN_PIXELS * 2);
          }
          onSizesUpdate({
            width: "".concat(finalWidth, "px"),
            height: finalHeight
          });
          return;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
  return BorderlessFrameObserver;
}(Component);
__decorate([bind(), __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", void 0)], BorderlessFrameObserver.prototype, "handleBodyMutation", null);
__decorate([bind(), __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", void 0)], BorderlessFrameObserver.prototype, "handleIntercomAppMutation", null);
function addMarginToPixels(pixelsString, margin) {
  var pixels = Number(pixelsString.replace('px', ''));
  return "".concat(pixels + margin, "px");
}
var Intercom = "Intercom_Intercom__3Amxb";
var IntercomHasLauncher = "Intercom_IntercomHasLauncher__2YqCZ";
var IntercomAnimating = "Intercom_IntercomAnimating__3MvHf";
var IntercomOpen = "Intercom_IntercomOpen__3SD9A";
var css$1 = ".Intercom_Intercom__3Amxb {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  z-index: 999;\n  width: 0;\n  height: 0;\n  background: transparent;\n  border: none; }\n\n.Intercom_IntercomHasLauncher__2YqCZ {\n  width: 90px;\n  height: 90px; }\n\n.Intercom_IntercomAnimating__3MvHf {\n  pointer-events: none; }\n\n.Intercom_IntercomOpen__3SD9A {\n  width: 100%;\n  max-width: 451px;\n  height: calc(100% - 40px);\n  min-height: 250px;\n  max-height: 704px; }\n  @media all and (max-width: 451px) {\n    .Intercom_IntercomOpen__3SD9A {\n      height: 100%;\n      max-height: none; } }\n";
styleInject(css$1);
var ANIMATION_DURATION = 300;
var Intercom$2 = /*#__PURE__*/function (_PureComponent3) {
  _inherits(Intercom$2, _PureComponent3);
  var _super4 = _createSuper(Intercom$2);
  function Intercom$2() {
    var _this3;
    _classCallCheck(this, Intercom$2);
    _this3 = _super4.apply(this, arguments);
    _this3.state = {
      frame: null
    };
    return _this3;
  }
  _createClass(Intercom$2, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref3) {
      var nextOpen = _ref3.open,
        nextUser = _ref3.user;
      var user = this.props.user;
      if (nextOpen) {
        this.getIntercom()('show');
      }
      if (nextUser && !objectEqual(user || {}, nextUser)) {
        this.getIntercom()('update', nextUser);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.getIntercom()('shutdown');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        appId = _this$props3.appId,
        launcher = _this$props3.launcher;
      var frame = this.state.frame;
      var importUrl = "https://widget.intercom.io/widget/".concat(appId);
      var borderlessFrameObserver = frame && createElement(BorderlessFrameObserver, {
        frame: frame,
        onSizesUpdate: this.handleBorderlessFrameSizesUpdate,
        launcher: launcher
      });
      return createElement(Fragment, null, createElement(ImportIsolatedRemote$2, {
        title: "intercom",
        source: importUrl,
        onImported: this.initializeIntercom
      }), borderlessFrameObserver);
    }
  }, {
    key: "updateState",
    value: function updateState(_ref4) {
      var _ref4$open = _ref4.open,
        open = _ref4$open === void 0 ? false : _ref4$open,
        _ref4$animating = _ref4.animating,
        animating = _ref4$animating === void 0 ? false : _ref4$animating,
        _ref4$borderlessFrame = _ref4.borderlessFrameSizes,
        borderlessFrameSizes = _ref4$borderlessFrame === void 0 ? null : _ref4$borderlessFrame;
      var launcher = this.props.launcher;
      var frame = this.state.frame;
      if (!frame) {
        return;
      }
      if (borderlessFrameSizes) {
        var width = borderlessFrameSizes.width,
          height = borderlessFrameSizes.height;
        frame.setAttribute('style', "width: ".concat(width, "; height: ").concat(height, ";"));
      } else {
        frame.removeAttribute('style');
      }
      var className = classNames(Intercom, launcher && IntercomHasLauncher, open && IntercomOpen, animating && IntercomAnimating);
      frame.setAttribute('class', className);
    }
  }, {
    key: "initializeIntercom",
    value: function initializeIntercom(frame) {
      var _this4 = this;
      var _this$props4 = this.props,
        open = _this$props4.open,
        onOpen = _this$props4.onOpen,
        onClose = _this$props4.onClose,
        appId = _this$props4.appId,
        onUnreadCountChange = _this$props4.onUnreadCountChange,
        user = _this$props4.user,
        onInitialization = _this$props4.onInitialization,
        launcher = _this$props4.launcher;
      var intercom = getIntercomFromFrame(frame);
      this.setState({
        frame: frame
      });
      intercom('boot', Object.assign({
        app_id: appId
      }, user, {
        hide_default_launcher: !launcher
      }));
      intercom('onShow', function () {
        _this4.updateState({
          open: true,
          animating: false
        });
        if (onOpen) {
          onOpen();
        }
      });
      intercom('onHide', function () {
        _this4.updateState({
          open: true,
          animating: true
        });
        setTimeout(function () {
          return _this4.updateState({
            open: false,
            animating: false
          });
        }, ANIMATION_DURATION);
        if (onClose) {
          onClose();
        }
      });
      if (onUnreadCountChange) {
        intercom('onUnreadCountChange', onUnreadCountChange);
      }
      if (open) {
        intercom('show');
      } else {
        this.updateState({
          open: false,
          animating: false
        });
      }
      this.injectCustomLauncherStyles();
      if (onInitialization) {
        onInitialization(intercom);
      }
    }
  }, {
    key: "getIntercom",
    value: function getIntercom() {
      var frame = this.state.frame;
      if (!frame) {
        return function () {};
      }
      return getIntercomFromFrame(frame);
    }
  }, {
    key: "injectCustomLauncherStyles",
    value: function injectCustomLauncherStyles() {
      var frame = this.state.frame;
      injectCustomStyles(frame, "\n      .intercom-launcher-frame-shadow {\n        box-shadow: none !important;\n      }\n    ");
    }
  }, {
    key: "handleBorderlessFrameSizesUpdate",
    value: function handleBorderlessFrameSizesUpdate(borderlessFrameSizes) {
      this.updateState({
        borderlessFrameSizes: borderlessFrameSizes
      });
    }
  }]);
  return Intercom$2;
}(PureComponent);
Intercom$2.defaultProps = {
  launcher: true
};
__decorate([bind(), __metadata("design:type", Function), __metadata("design:paramtypes", [HTMLIFrameElement]), __metadata("design:returntype", void 0)], Intercom$2.prototype, "initializeIntercom", null);
__decorate([bind(), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], Intercom$2.prototype, "handleBorderlessFrameSizesUpdate", null);
export default Intercom$2;